import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, Fragment, renderList, renderSlot, createTextVNode, toDisplayString, ref, watch, resolveComponent, createElementVNode, createBlock, createCommentVNode, createVNode, normalizeProps, guardReactiveProps, mergeProps, withCtx } from 'vue';
import { OrIconButtonV3 as script$2 } from '../or-icon-button-v3/index.js';
import { OrSortingV3 as script$3 } from '../or-sorting-v3/index.js';
import { OrSearchV3 as script$4 } from '../or-search-v3/index.js';
import { OrLoaderV3 as script$5 } from '../or-loader-v3/index.js';
import '../OrAutocompleteV3-8c6de221.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-label-v3/index.js';
import '../or-menu-item-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-popover-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import '../or-tags-v3/index.js';
import '../or-button-v3/index.js';
import '../or-tag-v3/index.js';
import '../or-menu-v3/index.js';

var CardCollectionView;
(function (CardCollectionView) {
  CardCollectionView["Grid"] = "grid";
  CardCollectionView["List"] = "list";
})(CardCollectionView || (CardCollectionView = {}));
const gridView = {
  view: CardCollectionView.Grid,
  icon: 'grid_view'
};
const listView = {
  view: CardCollectionView.List,
  icon: 'view_agenda'
};
const defaultViewModes = [gridView, listView];

const CardCollection = [
// Layout
'layout-column',
// Box
'h-full',
// Spacing
'gap-md'];
const CardCollectionToolbar = [
// Layout
'layout-row justify-between',
// Typography
'typography-body-2-regular',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const CardCollectionToolbarPanel = [
// Layout
'layout-inline-row',
// Spacing
'gap-lg+'];
const CardCollectionContent = [
// Layout
'grid',
// Overflow
'overflow-auto',
// Spacing
'px-[5px]',
// shadow width
'py-[5px]'];
const CardCollectionContentViews = {
  [CardCollectionView.Grid]: [
  // Layout
  'grid-cols-1 md:grid-cols-5',
  // Spacing
  'gap-sm md:gap-md'],
  [CardCollectionView.List]: [
  // Layout
  'grid-cols-1',
  // Spacing
  'gap-sm']
};
const CardCollectionEmptyContentItem = [
// Layout
'layout-column items-center justify-center h-full'];

var script$1 = defineComponent({
  name: 'OrCardCollectionView',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      required: true
    }
  },
  setup(props) {
    // Styles
    const rootStyles = computed(() => [...CardCollectionContent, ...CardCollectionContentViews[props.mode]]);
    return {
      rootStyles
    };
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(_ctx.rootStyles)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item, index) => {
    return renderSlot(_ctx.$slots, 'item', {
      key: item.key || index,
      index: index,
      item: item,
      mode: _ctx.mode
    }, () => [createTextVNode(toDisplayString(item.key), 1 /* TEXT */)]);
  }), 128 /* KEYED_FRAGMENT */)), renderSlot(_ctx.$slots, "viewEnd")], 2 /* CLASS */);
}

script$1.render = render$1;
script$1.__file = "src/components/or-card-collection-v3/partials/OrCardCollectionView.vue3.vue";

var script = defineComponent({
  name: 'OrCardCollection',
  components: {
    OrCardCollectionView: script$1,
    OrIconButton: script$2,
    OrSorting: script$3,
    OrSearch: script$4,
    OrLoader: script$5
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    view: {
      type: String,
      default: () => gridView.view
    },
    viewModes: {
      type: Array,
      default: () => defaultViewModes
    },
    sort: {
      type: String,
      default: undefined
    },
    sortOptions: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ''
    },
    searchPlaceholder: {
      type: String,
      default: undefined
    },
    searchDebounce: {
      type: Number,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: true
    }
  },
  emits: ['viewChange', 'sortChange', 'searchChange'],
  expose: ['root'],
  setup(props, context) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-card-collection-v3', ...CardCollection]);
    const toolbarStyles = computed(() => [...CardCollectionToolbar]);
    const toolbarPanelStyles = computed(() => [...CardCollectionToolbarPanel]);
    const emptyContainerStyles = computed(() => [...CardCollectionEmptyContentItem]);
    // State
    const proxyView = ref(props.view);
    const proxySearch = ref(props.search);
    // Methods
    function switchView(view) {
      proxyView.value = view;
    }
    function handleSearch(search) {
      proxySearch.value = search || '';
    }
    // Effects
    watch(() => props.view, value => {
      proxyView.value = value;
    });
    watch(proxyView, value => {
      context.emit('viewChange', value);
    });
    watch(() => props.search, value => {
      proxySearch.value = value;
    });
    watch(proxySearch, value => {
      context.emit('searchChange', value);
    });
    return {
      root,
      rootStyles,
      toolbarStyles,
      toolbarPanelStyles,
      emptyContainerStyles,
      proxyView,
      proxySearch,
      switchView,
      handleSearch
    };
  }
});

const _hoisted_1 = {
  key: 1,
  class: "layout-row gap-sm"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrSorting = resolveComponent("OrSorting");
  const _component_OrSearch = resolveComponent("OrSearch");
  const _component_OrIconButton = resolveComponent("OrIconButton");
  const _component_OrCardCollectionView = resolveComponent("OrCardCollectionView");
  const _component_OrLoader = resolveComponent("OrLoader");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.toolbarStyles)
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.toolbarPanelStyles)
  }, [_ctx.sortOptions.length ? (openBlock(), createBlock(_component_OrSorting, {
    key: 0,
    "model-value": _ctx.sort,
    options: _ctx.sortOptions,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('sortChange', $event))
  }, null, 8 /* PROPS */, ["model-value", "options"])) : createCommentVNode("v-if", true), renderSlot(_ctx.$slots, "toolbar")], 2 /* CLASS */), createElementVNode("div", {
    class: normalizeClass(_ctx.toolbarPanelStyles)
  }, [_ctx.enableSearch ? renderSlot(_ctx.$slots, "search", {
    key: 0
  }, () => [createVNode(_component_OrSearch, {
    "model-value": _ctx.proxySearch,
    class: "md:w-[350px]",
    placeholder: _ctx.searchPlaceholder,
    debounce: _ctx.searchDebounce,
    onSearch: _ctx.handleSearch
  }, null, 8 /* PROPS */, ["model-value", "placeholder", "debounce", "onSearch"])]) : createCommentVNode("v-if", true), _ctx.viewModes.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_1, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.viewModes, viewOption => {
    return openBlock(), createBlock(_component_OrIconButton, {
      key: viewOption.view,
      icon: viewOption.icon,
      size: 'l',
      selected: viewOption.view === _ctx.proxyView,
      onClick: $event => _ctx.switchView(viewOption.view)
    }, null, 8 /* PROPS */, ["icon", "selected", "onClick"]);
  }), 128 /* KEYED_FRAGMENT */))])) : createCommentVNode("v-if", true), renderSlot(_ctx.$slots, "addon")], 2 /* CLASS */)], 2 /* CLASS */), renderSlot(_ctx.$slots, "header", normalizeProps(guardReactiveProps({
    items: _ctx.items,
    mode: _ctx.proxyView
  }))), _ctx.items.length && !_ctx.loading ? renderSlot(_ctx.$slots, _ctx.proxyView, normalizeProps(mergeProps({
    key: 0
  }, {
    items: _ctx.items
  })), () => [createVNode(_component_OrCardCollectionView, {
    items: _ctx.items,
    mode: _ctx.proxyView
  }, {
    item: withCtx(props => [renderSlot(_ctx.$slots, "item", normalizeProps(guardReactiveProps(props)))]),
    viewEnd: withCtx(() => [renderSlot(_ctx.$slots, "viewEnd")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["items", "mode"])]) : createCommentVNode("v-if", true), _ctx.items.length === 0 || _ctx.loading ? (openBlock(), createElementBlock("div", {
    key: 1,
    class: normalizeClass(_ctx.emptyContainerStyles)
  }, [_ctx.proxySearch.length > 0 && !_ctx.loading ? renderSlot(_ctx.$slots, "noSearchResults", {
    key: 0,
    search: _ctx.proxySearch
  }, () => [createTextVNode(" No results ")]) : createCommentVNode("v-if", true), _ctx.loading ? renderSlot(_ctx.$slots, "loading", {
    key: 1
  }, () => [createVNode(_component_OrLoader)]) : createCommentVNode("v-if", true), _ctx.items.length === 0 && _ctx.proxySearch.length === 0 && !_ctx.loading ? renderSlot(_ctx.$slots, "empty", {
    key: 2
  }) : createCommentVNode("v-if", true)], 2 /* CLASS */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-card-collection-v3/OrCardCollection.vue";

export { CardCollectionView, script as OrCardCollectionV3, defaultViewModes, gridView, listView };
